var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mc-cascader',{staticClass:"cascader",attrs:{"data":_vm.wmCategoryList,"placeholder":"请选择品类","filterable":"","disabled":_vm.disabled,"props":{
        label: 'label',
        value: 'id',
        children: 'children'
    }},on:{"change":_vm.handleChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }